import { render, staticRenderFns } from "./RestockForm.vue?vue&type=template&id=7105d617"
import script from "./RestockForm.vue?vue&type=script&lang=js"
export * from "./RestockForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports